'use client'

import React from 'react'
import styles from './styles.module.css'
import { PALETTE } from '../../styles/constants'
import { MUI_THEME } from '../../styles/muiTheme'
import SearchIcon from '../icons/SearchIcon'
import { TextField } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'

function SearchInput({ onInputChange, placeholder, disabled, color = PALETTE.gray80 }) {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            display: 'flex',
            gap: '16px',
            color: `${color}`,

            borderRadius: '999px !important',
            border: `2px solid ${color}`,
            padding: '0px 24px !important',

            // update border color on focused state
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: `${color} !important`
            },

            //update font
            fontWeight: 400,
            fontFamily: 'Kanit',

            // MUI media queries, adjust text for screen sizes
            [MUI_THEME.breakpoints.up('xl')]: {
              fontSize: (20 ) + 'px'
            },
            [MUI_THEME.breakpoints.between('lg', 'xl')]: {
              fontSize: (18 ) + 'px'
            },
            [MUI_THEME.breakpoints.down('lg')]: {
              fontSize: (16 ) + 'px'
            },

            // update disabled styling
            '&.Mui-disabled': {
              WebkitTextFillColor: `${color} !important`,
              color: `${color} !important`,
              opacity: 0.8
            },
          },
          input: {
            '&.Mui-disabled': {
              WebkitTextFillColor: `${color} !important`,
              color: `${color} !important`,
              opacity: 0.8
            },
          },
        }
      },
    },
  })

  return (
    <div className={styles.wrapper}>
      <ThemeProvider theme={theme}>
        <TextField
          disabled={disabled}
          onChange={e => onInputChange(e.target.value)}
          fullWidth={true}
          variant="outlined"
          placeholder={placeholder}
          InputProps={{
            startAdornment: (
              <SearchIcon color="currentColor"/>
            ),
          }}
        />
      </ThemeProvider>
    </div>
  )
}

export default SearchInput
